module.exports = __webpack_public_path__ + "static/banner-5-about-us-d56b53c87c598397a51c9c59c5d033db.jpg";